import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import "./styles.css";

import BuildingSystemFilter from "../../Components/BuildingSystemFilter";
import OtherProjectProperties from "../../Components/OtherProjectProperties";
import CityStateFilter from '../../Components/CityStateFilter';

import CheckBoxRefinementList from '../../Components/CheckBoxRefinementList';

import ClearFilters from './ClearFilters';
import ShareSearch from './ShareSearch';

const ClearContainer = styled.div`
    margin-left: 8px;
    font-family: Open Sans, sans-serif;;
    padding-top: 12px;
`;

const ButtonContainer = styled.div`
    float: right;
    padding-right: 12px;
`;

export default function FilterPanel() {

    const {t, i18n} = useTranslation();
    //document.body.dir = i18n.dir();


    const tabs = [
        {
            id: 1, label: t('Building.System'), description: "Content of Tab 1",
            filterItem: <BuildingSystemFilter/>
        },
        {
            id: 2, label: t('Building.Type'), description: "Content of Tab 2",
            filterItem: <div className="form__row">
                <div className="form__group"><CheckBoxRefinementList limit={20} operator="or"
                                                                     attribute="building_type_name"
                                                                     initialFacets={window.all_building_types}/></div>
            </div>
        },
        {
            id: 3, label: t('Other.Properties'), description: "Content of Tab 3",
            filterItem: <OtherProjectProperties/>
        },
        {
            id: 4, label: t('Materials'), description: "Content of Tab 3",
            filterItem: <div className="form__row">
                <div className="form__group"><CheckBoxRefinementList limit={20} operator="or"
                                                                     attribute="material_type_names"
                                                                     initialFacets={window.all_material_types}/></div>
            </div>
        },
        {
            id: 5, label: t('Suppliers'), description: "Content of Tab 2",
            filterItem: <div className="form__row">
                <div className="form__group"><CheckBoxRefinementList limit={20} operator="or" attribute="partner_names"
                                                                     initialFacets={window.all_partners}/></div>
            </div>
        }
    ];


    return (
        <React.Fragment>
            <ClearContainer>
                <ButtonContainer>
                    <ClearFilters clearsQuery/>
                    <ShareSearch/>
                </ButtonContainer>
            </ClearContainer>
            <CityStateFilter/>
            <Accordion preExpanded={[1, 2, 3, 4, 5]} allowMultipleExpanded>
                {tabs.map(tab => (
                    <AccordionItem key={tab.id} uuid={tab.id}>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                {tab.label}
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filterItem">
                                {tab.filterItem}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                ))}
            </Accordion>
            <div className="form__row" style={{visibility: "hidden"}}>
                <div className="form__group"><CheckBoxRefinementList limit={20} operator="or" attribute="company_names"
                                                                     initialFacets={window.all_partners}/></div>
            </div>
        </React.Fragment>
    );
}

// class FilterPanel extends Component {
//   render() {
//     return (
//       <div className="map__results-inner" style={{background: '#fff', padding: '0px 20px 0px 20px'}}>
//         <CurrentRefinements />
//         <div className="form-default" style={{paddingTop: '25px'}}>
//           <FilterList title="Building System" path="building-types" operator="and" attribute="building_system_name" />
//           <FilterList title="Materials" path="material-types" operator="and" attribute="material_type_names" />
//           <FilterList title="Contruction Type" path="material-types" operator="and" attribute="construction_type_name" />
//         <FilterList title="Building Type" path="material-types" operator="and" attribute="building_type_name" />
//         </div>
//       </div>
//     );
//   }
// }
//
// export default FilterPanel;
